import { Picker } from "features/render";
import { ProcoreToolMode } from "slices/procoreUx";
import { TOOL_MODE_PICKERS } from "slices/procoreUx/utils";

export const measurePickers: Picker[] = TOOL_MODE_PICKERS[ProcoreToolMode.Measure];

export const sectionPickers: Picker[] = TOOL_MODE_PICKERS[ProcoreToolMode.Section];

export const currentModePickers: Picker[] = [...measurePickers, ...sectionPickers];
